import { ModalContent, ModalFooter } from '@components/modal';

const LandingModal = () => {
  const handleAccept = () => {
    sessionStorage.setItem('landingModalSeen', 'true');
  };

  return (
    <ModalContent title='DEPARTMENT OF DEFENSE TERMS OF AGREEMENT'>
      <section className='modal-body'>
        <p>
          <b>
            YOU ARE ACCESSING A U.S. GOVERNMENT (USG) INFORMATION SYSTEM (IS) THAT IS PROVIDED FOR USG-AUTHORIZED USE
            ONLY.
          </b>
        </p>
        <p>
          By using this IS (which includes any device attached to this IS), you can consent to the following conditions:
        </p>
        <p>
          The USG routinely intercepts and monitors communications on this IS for purposes including, but not limited
          to, penetration testing, COMSEC monitoring, network operations and defense, personnel misconduct (PM), law
          enforcement (LE), and counterintelligence (CI) investigations. At any time, the USG may inspect and seize data
          stored on this IS. Communications using, or data stored on, this IS are not private, are subject to routine
          monitoring, interceptions, and search, and may be disclosed or used for any USG-authorized purpose. This IS
          includes security measures (e.g., authentication and access controls) to protect USG interests--not for your
          personal benefit or privacy. Notwithstanding the above, using this IS does not constitute consent to PM, LE or
          CI investigative searching or monitoring of the content of privileged communications, or work product, to
          personal representation or services by attorneys, psychotherapists, or clergy, and their assistants. Such
          communications and work product are private and confidential. See User Agreement for details.
        </p>
      </section>
      <ModalFooter onSave={handleAccept} saveText='I Accept' />
    </ModalContent>
  );
};

export default LandingModal;
